import React from 'react';
import { useParams } from 'react-router';

import { useQuestionnaireQuestion, useQuestionnaireSections } from '@/features/constructor/hooks';
import { Question } from '@/features/constructorCommon';


export const QuestionnaireQuestion = ({questionProp, groupId, onCreated, ...props}) => {
  const { id } = useParams();
  const {
    handleCreate,
    handleUpdate,
    handleDelete,
    isCreating,
    isUpdating,
    isDeleting
  } = useQuestionnaireQuestion({questionnaireId: id});
  const { dataSorted: dataSortedSections, dataSortedSum: dataSortedSumSections, loading: loadingSections, answers: dependentAnswers, setAnswers: setDependentAnswers } = useQuestionnaireSections(
    id,
    questionProp ? questionProp.visibleConditions : null
  );

  return (
    <Question questionProp={questionProp} groupId={groupId} onCreated={onCreated} handleUpdate={handleUpdate}
              handleDelete={handleDelete}
              handleCreate={handleCreate}
              isCreating={isCreating}
              isUpdating={isUpdating}
              isDeleting={isDeleting}
              dataSortedSections={dataSortedSections}
              dataSortedSumSections={dataSortedSumSections}
              loadingSections={loadingSections}
              dependentAnswers={dependentAnswers}
              setDependentAnswers={setDependentAnswers}
              type="questionnaire"
              {...props} />
  );
};
